
export function signIn(userName: string, token: string) {
    return {
        type: "SIGN_IN",
        payload: {
            userName: userName,
            token: token
        }
    }
}

export function signOut() {
    return {
        type: "SIGN_OUT",
    }
}